import api from '../api';
let apiUrl = 'posts';

const state = {
    data: {},
    meta: {}
};

const actions = {
    show: async ({ commit }, id) => {
        return await api
            .get(`/api/v1/${apiUrl}/${id}`)
            .then((response) => {
                commit('set', response.data);
                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    }
};

const mutations = {
    set(state, data) {
        state.data = data.data;
        state.meta = data.meta;
    }
};

const getters = {
    get: (state) => {
        return state.data;
    },
    getMeta: (state) => {
        return state.meta;
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
